export const Eula = () => {
    return (
      <div className="eula">
        <h1>PlanetGazer End User License Agreement</h1>
  
        <p>
          <strong>Effective Date:</strong> August 13, 2026
        </p>
  
        <p>
          This End User License Agreement ("Agreement") governs your use of
          PlanetGazer ("PlanetGazer," "the application," "we," "us," or "our").
        </p>
  
        <p>
          By accessing or using PlanetGazer, you agree to this Agreement.
        </p>
  
        <h2>1. Purpose of PlanetGazer</h2>
  
        <p>
          PlanetGazer is software designed to provide astrological chart and
          transit information.
        </p>
  
        <p>
          PlanetGazer is currently a test and development application and is not
          currently offered as a production commercial service.
        </p>
  
        <h2>2. License</h2>
  
        <p>
          Subject to this Agreement, you may access and use PlanetGazer for lawful
          purposes.
        </p>
  
        <p>
          This Agreement does not transfer ownership of PlanetGazer or any
          associated software, source code, trademarks, designs, or other
          intellectual property.
        </p>
  
        <h2>3. Experimental Software</h2>
  
        <p>
          PlanetGazer is under development. Features may change, become
          unavailable, or be removed without notice. PlanetGazer may contain
          errors or defects, and functionality may not always be available.
        </p>
  
        <h2>4. QuickBooks Online</h2>
  
        <p>
          QuickBooks Online functionality is unrelated to PlanetGazer's astrology
          services.
        </p>
  
        <p>
          Any QuickBooks Online integration currently associated with PlanetGazer
          is a private development and testing integration used solely by the
          PlanetGazer owner with the owner's authorized QuickBooks Online company.
        </p>
  
        <p>
          The QuickBooks Online integration is not offered as a service to
          PlanetGazer users.
        </p>
  
        <h2>5. Acceptable Use</h2>
  
        <p>You agree not to:</p>
  
        <ul>
          <li>use PlanetGazer for unlawful purposes;</li>
          <li>
            attempt to gain unauthorized access to the application or its systems;
          </li>
          <li>
            interfere with the operation or security of the application;
          </li>
          <li>reverse engineer or circumvent security mechanisms; or</li>
          <li>
            use the application in a manner that could damage or impair its
            operation.
          </li>
        </ul>
  
        <h2>6. Intellectual Property</h2>
  
        <p>
          PlanetGazer and its associated software, designs, interfaces, code, and
          content are owned by or licensed to the PlanetGazer developer and are
          protected by applicable intellectual-property laws.
        </p>
  
        <p>
          No rights are granted except those expressly provided in this Agreement.
        </p>
  
        <h2>7. No Warranty</h2>
  
        <p>
          PlanetGazer is provided on an "as is" and "as available" basis.
        </p>
  
        <p>
          To the extent permitted by applicable law, we make no warranties
          regarding the availability, accuracy, reliability, or suitability of
          the application for any particular purpose.
        </p>
  
        <p>
          Astrological information provided by PlanetGazer is for informational
          and entertainment purposes and should not be relied upon as
          professional medical, financial, legal, or other professional advice.
        </p>
  
        <h2>8. Limitation of Liability</h2>
  
        <p>
          To the maximum extent permitted by applicable law, the PlanetGazer
          developer will not be liable for indirect, incidental, consequential,
          special, or punitive damages arising from or related to your use of the
          application.
        </p>
  
        <h2>9. Termination</h2>
  
        <p>
          Access to PlanetGazer may be suspended or terminated at any time,
          including if the application is discontinued or if you violate this
          Agreement.
        </p>
  
        <h2>10. Changes to This Agreement</h2>
  
        <p>
          We may modify this Agreement as PlanetGazer develops. Updated terms will
          be made available at this URL.
        </p>
  
        <h2>11. Contact</h2>
  
        <p>Questions regarding this Agreement may be directed to:</p>
  
        <p>
          <strong>PlanetGazer</strong>
          <br />
          Email:{" "}
          <a href="mailto:support@planetgazer.net">
            support@planetgazer.net
          </a>
        </p>
      </div>
    );
  };